module.exports = __webpack_public_path__ + "assets/img/7_1079.39d94f39.jpg";